import React from 'react';
import PropTypes from 'prop-types';
import {
  IconAlertCircleFilled,
  IconAlertTriangleFilled,
  IconCircleCheckFilled,
  IconInfoCircleFilled,
  IconX
} from '@tabler/icons-react';
import {
  TitledContainer,
  Container,
  Heading,
  TitledBody,
  TitledAction,
  Row,
  OutlineButton,
  GhostButton,
  CloseButton
} from './styled';

const FeatherAlert = ({
  children,
  variant,
  title,
  onClose,
  action,
  actionText,
  actionIcon,
  ...props
}) => {
  const getIcon = () => {
    switch (variant) {
      case 'error':
        return <IconAlertCircleFilled size={20} />;
      case 'success':
        return <IconCircleCheckFilled size={20} />;
      case 'warning':
        return <IconAlertTriangleFilled size={20} />;
      case 'information':
        return <IconInfoCircleFilled size={20} />;
      default:
        return null;
    }
  };

  if (title) {
    return (
      <TitledContainer role="alert" variant={variant} {...props}>
        {getIcon()}

        <div>
          <Heading $medium>{title}</Heading>
          <TitledBody>
            <p>{children}</p>

            {action && actionText ? (
              <TitledAction>
                <OutlineButton type="button" onClick={action}>
                  {actionText}
                  {actionIcon}
                </OutlineButton>
              </TitledAction>
            ) : null}
          </TitledBody>
        </div>

        {onClose ? (
          <CloseButton type="button" aria-label="Close" onClick={onClose} $titled>
            <IconX />
          </CloseButton>
        ) : null}
      </TitledContainer>
    );
  }

  return (
    <Container role="alert" variant={variant} {...props}>
      {getIcon()}

      <Row>
        <Heading>{children}</Heading>

        {action && actionText ? (
          <GhostButton type="button" onClick={action}>
            {actionText}
            {actionIcon}
          </GhostButton>
        ) : null}
      </Row>

      {onClose ? (
        <CloseButton type="button" aria-label="Close" onClick={onClose}>
          <IconX />
        </CloseButton>
      ) : null}
    </Container>
  );
};

FeatherAlert.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['error', 'success', 'warning', 'information']),
  title: PropTypes.string,
  onClose: PropTypes.func,
  action: PropTypes.func,
  actionText: PropTypes.string,
  actionIcon: PropTypes.node,
  className: PropTypes.string
};

FeatherAlert.defaultProps = {
  children: undefined,
  variant: 'error',
  title: undefined,
  onClose: undefined,
  action: undefined,
  actionText: undefined,
  actionIcon: undefined,
  className: undefined
};

export default FeatherAlert;
